module.exports = __webpack_public_path__ + "img/info-right.d5aa7583.jpg";